import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30411bd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "info"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.proposalContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('GOVERNANCE_VIEW.RECIPIENT')) + ":", 1 /* TEXT */),
        _createElementVNode("span", null, _toDisplayString($props.proposalContent.recipient), 1 /* TEXT */),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('GOVERNANCE_VIEW.AMOUNT')) + ":", 1 /* TEXT */),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.proposalContent.amount, (amount) => {
          return (_openBlock(), _createElementBlock("div", { key: amount }, [
            _createTextVNode(_toDisplayString(amount.amount) + " " + _toDisplayString(amount.denom) + " ", 1 /* TEXT */),
            _hoisted_2
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}